module.exports = __webpack_public_path__ + "88fcb6821a85e124c4c19f20feaf7755.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/industry.svg
// module id = 758
// module chunks = 0